import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Media } from '@classes/media/media';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as moment from 'moment';

export class MediaTest {
    date: Date;
    media: string;
}
@Injectable({
    providedIn: 'root'
})
export class mediaService {

    constructor(private http: HttpClient) { }
    private baseUrl: string = environment.apiUrl + '/medias';
    getMedias(formValue): Observable<Media[]> {

        let httpParams = new HttpParams();
        // ?filters=hasAlert==false&sorts=+createdOn

        const filtersQuery = ['hasAlert==false', 'type==1'];

        if (formValue) {
            const filters = formValue;



            if (filters.camera) {

                filtersQuery.push(`cameraId==${filters.camera}`);

            }
            if (filters.hours && filters.date) {

                let firstHour = filters.hours[0];

                let secondHour = filters.hours[1];

                let startDate = moment(filters.date).hours(firstHour).minutes(0).seconds(0).format('YYYY-MM-DDTHH:mm:ss');

                filtersQuery.push(`createdOn>=${startDate.toString()}`);

                if (secondHour) {
                    let endDate = moment(filters.date).hours(secondHour).minutes(59).seconds(59).format('YYYY-MM-DDTHH:mm:ss');
                    filtersQuery.push(`createdOn<=${endDate.toString()}`);
                }
                else {
                    let endDate = moment(filters.date).hours(firstHour).minutes(59).seconds(59).format('YYYY-MM-DDTHH:mm:ss');
                    filtersQuery.push(`createdOn<=${endDate.toString()}`);
                }
            }


        }
        httpParams = httpParams.append('Filters', filtersQuery.join()).append('sorts', 'createdOn');
        return this.http.get<Media[]>(`${environment.apiUrl}/medias`, {
            params: httpParams,
            headers: { authorization: `Bearer ${(environment.tokenKey)}` }
        });


    }


    /* -----------------------GET----------------------*/


    getMediaRequest() {
        return this.http.get<Media[]>(`${environment.apiUrl}/medias/requests`)
    }


    getMediaById(id: string): Observable<Blob> {

        return this.http.get(`${environment.apiUrl}/medias/${id}/file`, {
            observe: 'response', responseType: 'blob'
        })
            .pipe(map(res => res.body));
    }
    getRepeat(): MediaTest[] {
        let today = new Date();
        const tomorrow = new Date();
        tomorrow.setDate(today.getDate() + 1);
        let medias: MediaTest[] = [];


        do {
            const minutesToAdd = 5;
            const newMedia = new MediaTest();
            newMedia.media = '/assets/img/miniature.png'

            const futurDate = new Date(today.getTime() + minutesToAdd * 60000);
            newMedia.date = futurDate;
            today = futurDate;
            medias.push(newMedia);

        } while (new Date(today).getTime() !== new Date(tomorrow).getTime());


        return medias;
    }

    getThumbnail(id: string): Observable<Blob> {
        return this.http.get(`${environment.apiUrl}/medias/${id}/file`, {
            observe: 'response', responseType: 'blob'
        })
            .pipe(map(res => res.body));
    }




    /*--------------------POST------------------*/

    PostMedia(id: string): any {

        return this.http.post<any>(`${environment.apiUrl}/medias/${id}/request-video`, null);

    }


    /*----------------DELETE---------------------*/


    delete(ids: string[]): Observable<any> {
        const idList = {
            body: ids,
        };

        return this.http.request('delete', `${this.baseUrl}/requests`, idList);
    }
}
